import { Cd4peApiError } from '@utils/api/cd4pe';
import { StdVcsRepo, StdVcsSource } from '@utils/api/cd4pe/vcs/actions';
import * as vcsAt from '@utils/api/cd4pe/vcs/actionTypes';
import { EDIT_CODE_PROJECT_FORM_ACTION_TYPES } from '@codeDelivery/components/EditCodeProjectForm';
import { EditControlRepoActions } from './actions';
import * as at from './actionTypes';

export interface EditControlRepoState {
  sources: StdVcsSource[];
  selectedSource: string;
  repositories: StdVcsRepo[];
  name: string;
  saveControlRepoSuccess: boolean;
  currentModalClosed: boolean;
  getSourcesLoading: boolean;
  getSourcesError: string | null;
  getReposLoading: boolean;
  getReposError: string | null;
  saveControlRepoLoading: boolean;
  newControlRepoSource?: string | null;
  saveControlRepoError: Cd4peApiError | string | null;
  saveControlRepoWebhookError: boolean;
}

export const defaultEditControlRepoState: EditControlRepoState = {
  sources: [],
  selectedSource: '',
  repositories: [],
  name: '',
  saveControlRepoSuccess: false,
  currentModalClosed: false,
  getSourcesLoading: false,
  getSourcesError: null,
  getReposLoading: false,
  getReposError: null,
  saveControlRepoLoading: false,
  newControlRepoSource: null,
  saveControlRepoError: null,
  saveControlRepoWebhookError: false,
};

export const reducer = (
  state: EditControlRepoState,
  action: EditControlRepoActions,
): EditControlRepoState => {
  switch (action.type) {
    case vcsAt.GET_SOURCES_START:
      return {
        ...state,
        getSourcesLoading: true,
      };
    case vcsAt.GET_SOURCES_COMPLETE:
      return {
        ...state,
        getSourcesLoading: false,
        sources: action.payload,
      };
    case vcsAt.GET_SOURCES_ERROR:
      return {
        ...state,
        getSourcesLoading: false,
        getSourcesError: action.payload,
      };
    case vcsAt.GET_REPOS_START:
      return {
        ...state,
        getReposLoading: true,
      };
    case vcsAt.GET_REPOS_COMPLETE:
      return {
        ...state,
        getReposLoading: false,
        repositories: action.payload,
      };
    case vcsAt.GET_REPOS_ERROR:
      return {
        ...state,
        getReposLoading: false,
        getReposError: action.payload,
      };
    case at.EDIT_CONTROL_REPO_START:
      return {
        ...state,
        saveControlRepoLoading: true,
        getReposError: null,
        saveControlRepoError: null,
      };
    case at.EDIT_CONTROL_REPO_COMPLETE:
      return {
        ...state,
        saveControlRepoLoading: false,
        saveControlRepoSuccess: true,
      };
    case at.EDIT_CONTROL_REPO_ERROR:
      return {
        ...state,
        saveControlRepoLoading: false,
        saveControlRepoSuccess: false,
        saveControlRepoError: action.payload,
      };
    case at.EDIT_CONTROL_REPO_WEBHOOK_ERROR:
      return {
        ...state,
        saveControlRepoLoading: false,
        saveControlRepoSuccess: false,
        saveControlRepoWebhookError: true,
      };
    case EDIT_CODE_PROJECT_FORM_ACTION_TYPES.SELECTED_SOURCE:
      return {
        ...state,
        selectedSource: action.payload,
        repositories: [],
        name: '',
        saveControlRepoError: null,
        getReposError: null,
      };
    case EDIT_CODE_PROJECT_FORM_ACTION_TYPES.NAME:
      return {
        ...state,
        name: action.payload,
      };
    default:
      throw new Error();
  }
};
